export var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["UNDEFINED"] = "UNDEFINED";
    SubmissionStatus["PENDING"] = "PENDING";
    SubmissionStatus["CONFIRMED"] = "CONFIRMED";
    SubmissionStatus["PAYMENT_WAITING"] = "PAYMENT_WAITING";
    SubmissionStatus["PAYMENT_CANCELED"] = "PAYMENT_CANCELED";
})(SubmissionStatus || (SubmissionStatus = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Mode;
(function (Mode) {
    /** Any of the search terms must be present */
    Mode["OR"] = "OR";
    /** All search terms must be present */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    /** Existing or new contact */
    IdentityType["CONTACT"] = "CONTACT";
    /** Member is logged in, matching logic skipped */
    IdentityType["MEMBER"] = "MEMBER";
    /** Matching contact is a member, Merge logic won't be applied */
    IdentityType["NOT_AUTHENTICATED_MEMBER"] = "NOT_AUTHENTICATED_MEMBER";
})(IdentityType || (IdentityType = {}));
export var MarketingSubscriptionDetailsOptInLevel;
(function (MarketingSubscriptionDetailsOptInLevel) {
    MarketingSubscriptionDetailsOptInLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    MarketingSubscriptionDetailsOptInLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(MarketingSubscriptionDetailsOptInLevel || (MarketingSubscriptionDetailsOptInLevel = {}));
//# sourceMappingURL=types.impl.js.map